module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dPOq8"))).then(() => parcelRequire('2YFbr'));